import { useApiDelete, useApiPut } from '@/api/main/query'
import { ApiError } from '@/api/types'

import { useToast } from '@/shared/hooks'
import { useQueryClient } from '@tanstack/react-query'
import { paymentRequisitsAPI } from '../api'

const invalidateRequisitesData = (queryClient: ReturnType<typeof useQueryClient>) => {
  queryClient.invalidateQueries({ queryKey: ['requisites'] })
  queryClient.invalidateQueries({ queryKey: ['requisite-daily-stat'] })
  queryClient.invalidateQueries({ queryKey: ['requisite-total-stat'] })
}

export const usePaymentRequisitActions = (
  queryKey: string[],
  activePaymentRequisit: string,
  onSuccessCallback?: () => void
) => {
  const { addToast } = useToast()
  const queryClient = useQueryClient()

  const handleSuccess = (message: string) => {
    addToast('Успех!', message, 'success')
    invalidateRequisitesData(queryClient)

    if (queryKey.length) {
      queryClient.invalidateQueries({ queryKey })
    }

    if (onSuccessCallback) onSuccessCallback()
  }

  const handleError = (error: ApiError) => {
    addToast('Ошибка!', error.message, 'error')
  }

  const { mutate: disablePaymentRequisit } = useApiPut(
    paymentRequisitsAPI.disable(activePaymentRequisit),
    {
      onSuccess: () => handleSuccess('Метод оплаты остановлен'),
      onError: handleError,
    }
  )

  const { mutate: enablePaymentRequisit } = useApiPut(
    paymentRequisitsAPI.enable(activePaymentRequisit),
    {
      onSuccess: () => handleSuccess('Метод оплаты включен'),
      onError: handleError,
    }
  )

  const { mutate: deletePaymentRequisit } = useApiDelete(paymentRequisitsAPI.delete, {
    onSuccess: () => handleSuccess('Метод оплаты удален'),
    onError: handleError,
  })

  return {
    disablePaymentRequisit: (id: string) => disablePaymentRequisit(id),
    enablePaymentRequisit: (id: string) => enablePaymentRequisit(id),
    deletePaymentRequisit: (id: string) => deletePaymentRequisit(id),
  }
}
